import { InlineSvg, Text } from "@salestrak/ui";
import { countryFlag } from "#app/lib/custom-field-utils";
import * as flagSvgs from "country-flag-icons/string/3x2";

const FLAG_ASPECT_RATIO = 2 / 3;
const flagSvgMap = flagSvgs as Record<string, string>;

function getFlagSvg(iso: string): string | null {
  return flagSvgMap[iso] ?? null;
}

// The source flag markup carries only a viewBox, so inject explicit
// width/height onto its root element for a fixed pixel size. Trusted static
// markup from `country-flag-icons`, never user input.
export function CountryFlagImage({ iso, size = 20 }: { iso: string; size?: number }) {
  const svg = getFlagSvg(iso);
  if (!svg) return <Text size="sm">{countryFlag(iso)}</Text>;
  return <InlineSvg height={Math.round(size * FLAG_ASPECT_RATIO)} markup={svg} width={size} />;
}
